import React from 'react';

const RightSidebar = ({ isOpen, onClose, currentPage }) => {
  // 現在のページに基づいて適切な内容を表示
  const renderContent = () => {
    switch(currentPage) {
      case 'shifts':
        return (
          <>
            <div className="sidebar-section">
              <h4>シフト操作</h4>
              <button className="action-btn">新規シフト追加</button>
              <button className="action-btn">シフト一括登録</button>
              <button className="action-btn">シフト表を印刷</button>
            </div>
          </>
        );
      
      case 'stores':
        return (
          <>
            <div className="sidebar-section">
              <h4>店舗操作</h4>
              <button className="action-btn">新規店舗追加</button>
              <button className="action-btn">一括インポート</button>
            </div>
          </>
        );
      
      case 'staff':
        return (
          <>
            <div className="sidebar-section">
              <h4>スタッフ操作</h4>
              <button className="action-btn">新規スタッフ追加</button>
              <button className="action-btn">CSVインポート</button>
            </div>
          </>
        );
      
      default:
        return (
          <div className="sidebar-section">
            <h4>クイックアクション</h4>
            <button className="action-btn">ダッシュボードを更新</button>
          </div>
        );
    }
  };
  
  return (
    <div className={`right-sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="right-sidebar-header">
        <h3>操作パネル</h3>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
      
      <div className="right-sidebar-content">
        {renderContent()}
        
        <div className="sidebar-section">
          <h4>フィルター</h4>
          <div className="filter-option">
            <label>
              <input type="checkbox" defaultChecked />
              社員
            </label>
          </div>
          <div className="filter-option">
            <label>
              <input type="checkbox" defaultChecked />
              パート
            </label>
          </div>
          <div className="filter-option">
            <label>
              <input type="checkbox" defaultChecked />
              アルバイト
            </label>
          </div>
        </div>
        
        <div className="sidebar-section">
          <h4>統計</h4>
          <div className="stat-item">
            <span className="stat-label">総シフト数:</span>
            <span className="stat-value">26</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">総労働時間:</span>
            <span className="stat-value">182時間</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSidebar;
